
import React from "react";
import { currencyFormat } from "../utils";
import Text from "./Text";

const FormattedPrice = ({
  price,
  negative = "",
  align = "left",
  suffix = "",
  textColor,
  ...restProps

}) => {
  return (
    <Text align={align} testId="formatted-price" {...restProps} color={textColor}>
      {!isNaN(price) ? `${negative && "-"} $${currencyFormat(price)}` : "$0.00"}
      {suffix}
    </Text>
  );
};

export default FormattedPrice;
